import type { MobileBottomPanelType } from '@ui/MobileBottomPanel/component'
import type { ModalType } from '@ui/Modal/component'
import type { SidePanelType } from '@ui/SidePanel/component'

type Panel = ModalType | SidePanelType | MobileBottomPanelType

const set = new Set<Panel>()

export const add = (el: Panel): void => {
  set.add(el)
}

export const remove = (el: Panel): void => {
  set.delete(el)
}

export const has = (el: Panel): boolean => {
  return set.has(el)
}

export const getAll = (): Panel[] => {
  return Array.from(set)
}
